<template>
  <div class="clearfix">
    <ul>
      <li>
        <a @click="change('list')" :class="{ active: active === 'list' }">Lista</a>
      </li>
      <li>
        <a @click="change('map')" :class="{ active: active === 'map' }">Karta</a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    activeValue: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      active: 'list',
    };
  },
  methods: {
    change(choice) {
      this.active = choice;
      this.$emit('update:modelValue', choice); // Update the parent
    },
  },
};
</script>
<style lang="scss" scoped>
ul {
  border: 1px solid $abgblue;
  border-radius: 4px;
  overflow: hidden;
  display: flex;
  flex-direction: row;
}

li{
  display:block;
  font-size: 15px;
  text-align: center;
  margin-right: 0;

  a{
    display: block;
    text-decoration: none;
    font-weight: bold;
    padding: 11px 20px;
    color: $abgblue;
    background-color: $abglightblue;
    cursor: pointer;
    letter-spacing: 0.18px;

    &.router-link-active, &.active {
      color: $textcolorwhite;
      background: $abgblue;
    }

  }
}
</style>
